import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../common/services/base-crud.service';
import { environment } from '../../../environments/environment';
import { BankCardForm, BankCardItem } from '../interfaces/card.interface';
import { Observable } from 'rxjs';
import { ApiItemResponse } from '../models/api';

@Injectable()
export class CardsService extends BaseCrudService<BankCardItem, BankCardForm> {
  protected resource = 'cards';
  protected apiRoot = environment.baseUrl;
  baseUrl: string = `${environment.baseUrl}`;

  getOperatorCard(conversation: string): Observable<ApiItemResponse<BankCardItem>> {
    return this.http.post<ApiItemResponse<BankCardItem>>(
      `${this.apiRoot}/${this.resource}/send/operator-card`,
      { conversation },
    );
  }
}
